/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_List_Gp_Notfound2Inputs */

const en_coinvestments_list_gp_notfound2 = /** @type {(inputs: Coinvestments_List_Gp_Notfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No co-investments found`)
};

/**
* | output |
* | --- |
* | "No co-investments found" |
*
* @param {Coinvestments_List_Gp_Notfound2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_list_gp_notfound2 = /** @type {((inputs?: Coinvestments_List_Gp_Notfound2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_List_Gp_Notfound2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_list_gp_notfound2(inputs)
});
export { coinvestments_list_gp_notfound2 as "coInvestments_list_gp_notFound" }